var cilViewColumn = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M16,64V448H496V64ZM320,96V416H192V96ZM48,96H160V416H48ZM464,416H352V96H464Z' class='ci-primary'/>"];

export { cilViewColumn };
//# sourceMappingURL=cil-view-column.js.map
